<payee-popup
  title="Ügy létrehozása"
  description="Válaszd ki a fennhatóságot és a terméket"
>
  <payee-form-field width="max">
    <span payee-label>Fennhatóság</span>
    <payee-autocomplete
      placeholder="Válassz fennhatóságot"
      [formControl]="jurisdictionControl"
      [options]="jurisdictionOptions"
      [displayWith]="jurisdictionDisplayWith"
    ></payee-autocomplete>
  </payee-form-field>
  <payee-form-field width="max">
    <span payee-label>Termék</span>
    <payee-autocomplete
      placeholder="Válassz terméket"
      [formControl]="productControl"
      [options]="productOptions"
      [displayWith]="productDisplayWith"
    ></payee-autocomplete>
  </payee-form-field>
  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading || jurisdictionControl.invalid || productControl.invalid"
      (click)="submit()"
    >
      Létrehozás
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      (click)="cancel()"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
